import React, { useState, useEffect } from 'react';
import Footer from '../../component/Footer';
import Navbar from '../../component/Navbar';
import { Link, useNavigate } from 'react-router-dom';
import Quote from './Quote';
import DailyLogs from './DailyLogs';
import Arrow from '../Arrow';
import Generalsidebar from '../Generalsidebar';

const moodURL = 'https://thrive-mqy3.onrender.com/v1/moods';
const MoodTrack = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  
  const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'))
    ? JSON.parse(localStorage.getItem('userLoggedIn'))
    : { firstName: '' };

  console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  const [showQoute, setshowQoute] = useState();
  const [showDailyLogs, setShowDailyLogs] = useState();
  const [moodEntry, setMoodEntry] = useState('');
  const [veryHappyCount, setVeryHappyCount] = useState(0);
  const [chillCount, setChillCount] = useState(0);
  const [neutralCount, setNeutralCount] = useState(0);
  const [happyCount, setHappyCount] = useState(0);
  const [sadCount, setSadCount] = useState(0);
  const [angryCount, setAngryCount] = useState(0);
  const [stressedCount, setStressedCount] = useState(0);
  const [anxiousCount, setAnxiousCount] = useState(0);
  const [excitedCount, setExcitedCount] = useState(0);
  const [isValueAvailable, setIsValueAvailable] = useState(false);
  const [mood, setMood] = useState('');
  const [note, setNote] = useState('');
  const navigate = useNavigate();
  const accessToken = localStorage.getItem('accessToken');

  const dailyDate = new Date().toLocaleDateString('en-us', {
    weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  const handleEntrySubmit = (e) => {
    e.preventDefault();

    localStorage.setItem('Entry', moodEntry);
    setIsValueAvailable((isValueAvailable) => !isValueAvailable);
    console.log(isValueAvailable);
  };

  const userEntry = localStorage.getItem('Entry');

  const sendMood = async () => {
    try {
      const moodDetails = {
        mood,
        note,
      };
      console.log('moodResponse', moodDetails);
      const userDetail = {
        method: 'POST',
        body: JSON.stringify(moodDetails),
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'content-Type': 'application/json',
        },
      };

      const response = await fetch(moodURL, userDetail);
      const data = await response.json();
      console.log("today's mood", data);
    } catch (error) {
      console.log('something went wrong' + error);

      return;
    }
  };

  return (
    <div>
      <Navbar />

      <div onClick={handleArrowClick} className='absolute top-24 left-12 z-20'>
        <Arrow />
      </div>
      <div className={showSidebar ? 'show-sidebar' : 'hidden'}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>

      <div className='bg-[#D4DDCC]'>
        <Quote showQoute={showQoute} setshowQoute={setshowQoute} />
        {/* body div holdind the both div-------- */}
        <div className='flex'>
          {/* 70% main div-------- */}
          <div className='w-2/3'>
            <div className='flex justify-between m-10'>
              <h3 className='m-5 text-[#295700] font-bold'>{dailyDate}</h3>
              <button
                onClick={() => setshowQoute(!showQoute)}
                className='m-5 bg-[#2A3D19] p-4 rounded-[5px] text-white font-bold quote'>
                Quote of the day
              </button>
            </div>
            {/* emoji div--------------- */}
            <div className='bg-[#F5F5F5] rounded-[5px] m-10 text-center shadow-md w-[816px] h-[197px]'>
              <div className='pt-10'>
                <h1 className='text-[#295700] font-semibold px-4'>
                  Hey there {userInfo.firstName} 👋, how are you feeling today?
                </h1>
              </div>
              <div className='flex gap-10 m-5 px-4 dailyMood onsubmit= addEmoji(event)'>
                <button
                  className='excitedButton'
                  onClick={() => {
                    setMood('excited');
                    setExcitedCount(excitedCount + 1);
                  }}>
                  <p>🤩</p>
                  <p>Excited</p>
                </button>
                <button
                  className='veryHappyButton '
                  onClick={() => {
                    setMood('veryHappy');
                    setVeryHappyCount(veryHappyCount + 1);
                  }}>
                  <p>😃</p>
                  <p>Very Happy</p>
                </button>
                <button
                  className='happyButton'
                  onClick={() => {
                    setMood('happy');
                    setHappyCount(happyCount + 1);
                  }}>
                  <p>😄</p>
                  <p>Happy</p>
                </button>
                <button
                  className='chillButton'
                  onClick={() => {
                    setMood('chill');
                    setChillCount(chillCount + 1);
                  }}>
                  <p>😎</p>
                  <p>Chill</p>
                </button>
                <button
                  className='neutralButton'
                  onClick={() => {
                    setMood('neutral');
                    setNeutralCount(neutralCount + 1);
                  }}>
                  <p>😐</p>
                  <p>Neutral</p>
                </button>
                <button
                  className='sadButton'
                  onClick={() => {
                    setMood('sad');
                    setSadCount(sadCount + 1);
                  }}>
                  <p>😭</p>
                  <p>Sad</p>
                </button>
                <button
                  className='anxiousButton'
                  onClick={() => {
                    setMood('anxious');
                    setAnxiousCount(anxiousCount + 1);
                  }}>
                  <p>😖</p>
                  <p>Anxious</p>
                </button>
                <button
                  className='angryButton '
                  onClick={() => {
                    setMood('angry');
                    setAngryCount(angryCount + 1);
                  }}>
                  <p>😡</p>
                  <p>Angry</p>
                </button>
                <button
                  className='stressedButton'
                  onClick={() => {
                    setMood('Stressed');
                    setStressedCount(stressedCount + 1);
                  }}>
                  <p>😩</p>
                  <p>Stressed</p>
                </button>
              </div>
            </div>
            <div className='flex justify-between mt-7 mx-10'>
              <div
                className='m-5 bg-[#2A3D19] p-4 rounded-[5px] text-white font-bold cursor-pointer'
                onClick={() => setShowDailyLogs(true)}>
                Today's Log
              </div>
              <Link to='/moodui'>
                <div
                  className='m-5 bg-[#2A3D19] p-4 rounded-[5px] text-white font-bold cursor-pointer'
                  onClick={() => {}}>
                  View Previous Logs
                </div>
              </Link>
            </div>
            <div>
              <DailyLogs
                showDailyLogs={showDailyLogs}
                setShowDailyLogs={setShowDailyLogs}
                note={note}
                setNote={setNote}
                sendMood={sendMood}
              />
            </div>
          </div>
          {/* 30% main div--------- */}
          <div className='w-1/3'>
            <div className='rounded-[5px] m-10 shadow-md w-[Fixed (390px)] h-[197px] p-7'>
              <h1 className='text-[#295700] font-bold text-2xl'>Insights</h1>
              <h3 className='text-[#295700] mt-3 font-semibold'>
                In the past 7 days...
              </h3>
              <div className='dailyMoodAppend'>
                <h3 className='text-[#295700] mt-3'>
                  Excited 🤩 -{excitedCount} day(s)
                </h3>
                <h3 className='text-[#295700]'>
                  Anxious 😖 -{anxiousCount} day(s)
                </h3>
                <h3 className='text-[#295700]'>
                  Happy 😄 -{happyCount} day(s)
                </h3>
              </div>
            </div>
            <div className='rounded-[5px] m-10 shadow-md w-[Fixed (390px)] h-[197px] p-7'>
              <h1 className='text-[#295700] font-semibold'>
                In the past month...
              </h1>
              <h1 className='text-[#295700] mt-3'>Excited 🤩 - 2 day(s)</h1>
              <h1 className='text-[#295700]'>Anxious 😖 - 1 day(s)</h1>
              <h1 className='text-[#295700]'>Happy 😄 - 2 day(s)</h1>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default MoodTrack;
